import startCase from 'lodash/startCase';
import { courseQuery, courses_for_selectQuery, courses_for_timetable_selectQuery } from '@app-types/graphql-types';
import { HSMSSelectOption } from '@components/shared';

export const getCoursesForSelect = (
  courses?: (
    | courseQuery['course'][0]
    | courses_for_selectQuery['course'][0]
    | courses_for_timetable_selectQuery['course'][0]
  )[],
): HSMSSelectOption[] => {
  if (courses) {
    const coursesForSelect = courses.map((course) => {
      return {
        value: course.id,
        label: `${startCase(course.code)} - ${course.name}`,
      };
    });

    return coursesForSelect.sort((firstValue, secondValue) => firstValue.label.localeCompare(secondValue.label));
  }

  return [];
};
